import resolve from 'ioc/resolve'

class CustomerCleanupPromptController {
    constructor($rootScope, $uibModalInstance, options) {
        var $ctrl = this;
		var model = $ctrl.model = options.model;
		$ctrl.modal = $uibModalInstance;
		$ctrl.$dismiss = $ctrl.dismiss = $uibModalInstance.dismiss;
		$ctrl.$close = $ctrl.close = $uibModalInstance.close;
        $ctrl.title = options.title || 'Customer Cleanup...';
		$ctrl.options = options;

	}
}

export default CustomerCleanupPromptController;